/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as creditCardActions from './CreditCard-Actions';
import * as creditCardOperations from './CreditCard-Operations';
import reducer from './CreditCard-Reducers';

const creditCardWatcherSagas = [
    ...creditCardOperations.watchers,
];

export { creditCardWatcherSagas, creditCardOperations, creditCardActions };

export default reducer;
